"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _iterableToArray;

var _from = _interopRequireDefault(require("../../core-js/array/from"));

var _isIterable2 = _interopRequireDefault(require("../../core-js/is-iterable"));

var _symbol = _interopRequireDefault(require("../../core-js/symbol"));

function _iterableToArray(iter) {
  if (typeof _symbol.default !== "undefined" && (0, _isIterable2.default)(Object(iter))) return (0, _from.default)(iter);
}